import { render, staticRenderFns } from "./DrugTaboo.vue?vue&type=template&id=0c177be0&scoped=true"
import script from "./DrugTaboo.vue?vue&type=script&lang=js"
export * from "./DrugTaboo.vue?vue&type=script&lang=js"
import style0 from "./DrugTaboo.vue?vue&type=style&index=0&id=0c177be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c177be0",
  null
  
)

export default component.exports